import { useSortable } from '@dnd-kit/sortable';
import React, { useRef, useState } from 'react'
import FlexComponent from '../../FlexComponent';
import { Checkbox } from 'primereact/checkbox';
import { Avatar } from 'primereact/avatar';
import { Mention } from 'primereact/mention';
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import axios from '../../../utils/axios';
import { createCheckList, createAppDoc, deleteCheckList, updateCheckList } from '../../../utils/urls'
import { CSS } from "@dnd-kit/utilities";
import { FileUpload } from 'primereact/fileupload';
import AppModal from '../../../shared/AppModal';
import PreviewFile from './PreviewFile';

function CheckListItem({ list, index, usersList, convertDateToString, getNameById, userTemplate, getInitials, itemTemplate, setIsCheckListEdit,
    setCheckLists,
    setIsCheckListAdd,
    updateCheckList,
    userId,
    formId,
    toast,
    handleClose,
    setValue,
    setMentionedUsers,
    setAssignedUsers,
    setDueDate,
    checkLists,
    suggestions,
    onSearch,
    convertDateToDateString,
    setCheckListEditIndex,
    checkListEditIndex,
    isCheckListEdit }) {

    const [editCheckListValue, setEditCheckListValue] = useState(null)
    const [editMentionedUsers, setEditMentionedUsers] = useState([]);
    const [editAssignedUsers, setEditAssignedUsers] = useState([])
    const [editDueDate, setEditDueDate] = useState('')

    const editDueDateOp = useRef(null);
    const editAssignOp = useRef(null);

    const [existingFiles, setExistingFiles] = useState([]);
    const [files, setFiles] = useState([]);
    const fileUploadRef = useRef(null);
    const [removedFileIds, setRemovedFileIds] = useState([]);
    const [saveEditLoading, setSaveEditLoading] = useState(false);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: list.checklist_id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        width: "100%",
        // background: "white",
        // padding: "0.4rem 1rem",
        // margin: "0.75rem 2%",
        // marginTop: ".5rem",
        border: '1px solid grey',
        borderRadius: "5px"
        // display: hideCheckedItems && list.completed ? 'none' : '' 
    };

    // console.log(checkLists)
    const handleSaveEditCheckList = async (list) => {
        setSaveEditLoading(true);
        try {
            // Step 1: upload new files to /api/app-docs/
            let newAppDocIds = [];
            if (files.length > 0) {
                const uploaded = await Promise.all(
                    files.map(f => {
                        const fdDoc = new FormData();
                        fdDoc.append('app_id', formId);
                        fdDoc.append('file', f.file);
                        fdDoc.append('file_name', f.editedName);
                        return axios.post(createAppDoc, fdDoc, { headers: { 'Content-Type': 'multipart/form-data' } })
                            .then(r => r.data);
                    })
                );
                newAppDocIds = uploaded.map(d => d.app_doc_id);
            }

            // Step 2: update checklist item with app_doc_ids
            const formData = new FormData();
            formData.append('item', editCheckListValue);
            formData.append('due_date', editDueDate ? convertDateToString(editDueDate) : list.due_date);
            formData.append('is_completed', list.completed || false);
            formData.append('mention', JSON.stringify(editMentionedUsers.map(user => ({ id: user.id }))));
            formData.append('assigned_user', JSON.stringify(editAssignedUsers.map(id => ({ id }))));
            formData.append('removed_file_ids', JSON.stringify(removedFileIds));
            formData.append('renamed_files', JSON.stringify(existingFiles.map(file => ({ id: file.id, file_name: file.editedName }))));
            if (newAppDocIds.length > 0) {
                formData.append('app_doc_ids', JSON.stringify(newAppDocIds));
            }

            const response = await axios.post(`${updateCheckList}${list.checklist_id}/${userId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.status === 200) {
                setIsCheckListEdit(false);
                setIsCheckListAdd(false);
                const updatedItem = response.data;
                setCheckLists(prevItems =>
                    prevItems.map(item =>
                        item.checklist_id === list.checklist_id
                            ? { ...item, item: updatedItem.item, mention: updatedItem.mention || [], assigned_user: updatedItem.assigned_user || [], due_date: updatedItem.due_date, file_url: updatedItem.file_url || [] }
                            : item
                    )
                );
                setEditCheckListValue('');
                setEditMentionedUsers([]);
                setEditAssignedUsers([]);
                setEditDueDate('');
                setFiles([]);
                setRemovedFileIds([]);
                if (fileUploadRef?.current) fileUploadRef.current.clear();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleClose();
            }
        } catch {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            handleClose();
        } finally {
            setSaveEditLoading(false);
        }
    };

    const openPreview = (file) => {
        setPreviewFile(file);
        setPreviewVisible(true);
    };

    const handleDelete = (list) => {
        const updatedData = checkLists?.filter(item => item.checklist_id !== list.checklist_id);
        setCheckLists(updatedData);
        const Url = `${deleteCheckList}${list.checklist_id}/${userId}`
        axios.post(Url, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {

                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleClose()
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleClose()
            })

    };

    function getImageById(id) {
        const item = usersList.find(obj => obj.value === id);
        return item ? item.image : null; // Return the name if found, otherwise return null
    }

    function formatDateString(dateString) {
        const date = new Date(dateString + 'T00:00:00');
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    }


    const convertDateStringToDate = (dateString) => {
        if (!dateString) return null;
        const [year, month, day] = dateString.split('-');
        return new Date(year, month - 1, day); // month is 0-based in Date
    };


    const handleEdit = (index) => {
        setIsCheckListAdd(false)
        setIsCheckListEdit(true);
        setCheckListEditIndex(index);
        setEditCheckListValue(checkLists[index].item);
        setEditAssignedUsers(checkLists[index].assigned_user.map(list => list.id))
        setEditDueDate(convertDateStringToDate(checkLists[index].due_date))
        setEditMentionedUsers(checkLists[index].mention)
        setExistingFiles(
            checkLists[index].file_url?.map(file => ({
                ...file,
                editedName: file.file_name
            })) || []
        );
        // setEditUsers(extractUsers(commentsData[index].comment));
    };

    const onListChange = (e, list) => {
        const { value, checked } = e.target;

        setCheckLists((prevCheckLists) =>
            prevCheckLists.map((list) =>
                list.checklist_id === value.checklist_id
                    ? { ...list, completed: checked }
                    : list
            )
        );

        const {
            completed,
            checklist_id,
            created_at,
            created_by_image,
            assigned_user,
            created_by_name,
            mention,
            ...listData
        } = list;

        const formData = new FormData();

        // append normal fields
        Object.keys(listData).forEach((key) => {
            if (listData[key] !== null && listData[key] !== undefined) {
                formData.append(key, listData[key]);
            }
        });

        // append arrays as JSON strings
        formData.append(
            "assigned_user",
            JSON.stringify(
                assigned_user.map((item) => ({
                    id: item.id
                }))
            )
        );

        formData.append(
            "mention",
            JSON.stringify(
                mention.map((item) => ({
                    id: item.id
                }))
            )
        );

        formData.append("is_completed", checked);

        const Url = `${updateCheckList}${list.checklist_id}/${userId}`;

        axios.post(Url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Something went wrong',
                        life: 3000
                    });

                    handleClose();
                }
            })
            .catch(() => {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong',
                    life: 3000
                });

                handleClose();
            });
    };

    const highlightMentions = (text) => {
        if (!text) return text;
        const mentionRegex = /@[\w.-]+/g;
        const parts = text.split(mentionRegex);
        const mentions = text.match(mentionRegex) || [];

        const result = [];
        parts.forEach((part, index) => {
            result.push(part);
            if (mentions[index]) {
                result.push(<span key={index} style={{ color: "#2FC623" }} className="mention">{mentions[index]}</span>);
            }
        });

        return result;
    };

    const handleDownload = async (file) => {
        try {
            const response = await axios.get(file.file_url, { responseType: 'blob' });
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = file.file_name || 'downloaded-file';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            window.open(file.file_url, "_blank");
        }
    };

    const headerElement = (
        <FlexComponent justifyContent="start" gap=".5rem" >
            <div>{previewFile?.file_name || "Preview"}</div>
            <Button
                icon="pi pi-download"
                rounded
                text
                severity="success"           // Green color
                onClick={() => handleDownload(previewFile)}
                tooltip="Download file"
            />
        </FlexComponent>
    );

    return (

        <div className="list-row" ref={setNodeRef} key={list.checklist_id} style={style} >
            {/* <Checkbox inputId={list.checklist_id} name="list" value={list} onChange={onListChange} checked={list.completed} />
                <span htmlFor={list.checklist_id} =onClick{() => {
                    }} style={{ marginLeft: "0.5rem", textDecoration: list.completed ? 'line-through' : '', cursor: "pointer" }} >
                    {list.item}
                    </span> */}
            <FlexComponent className='checkListItem' alignItems="start" gap=".3rem" style={{ padding: "0.5rem", borderRadius: ".5rem" }}>
                <span style={{ cursor: "pointer", fontSize: "15px", touchAction: "none" }} {...attributes} {...listeners}>⣿</span>
                <Checkbox inputId={list.checklist_id} name="list" value={list} onChange={(event) => {
                    onListChange(event, list)
                }} checked={list.completed} />
                {!isCheckListEdit || checkListEditIndex !== index ? (
                    <FlexComponent className="applicantContainer" justifyContent="start" >
                        <div onClick={() => {
                            handleEdit(index)
                        }} className={`applicantDivs ${(list.assigned_user.length || list?.due_date) ? "checklistItemRow" : ""}`} htmlFor={list.checklist_id} style={{ display: "flex", justifyContent: "space-between", width: "100%", marginLeft: "0.5rem", cursor: "pointer" }} >
                            <div style={{ textDecoration: list.completed ? 'line-through' : '' }}> {highlightMentions(list.item)}</div>
                            <FlexComponent className='fullWidth' gap="1rem" style={{ width: "auto" }} >
                                <div>{list?.due_date ? <span style={{ fontSize: "14px" }} ><i className="pi pi-clock" style={{ marginRight: '5px' }}></i>{formatDateString(list?.due_date)}</span> : ''}</div>
                                <div style={{ display: "flex" }} >
                                    {/* {list.assigned_user.length === 0 && <i className="pi pi-user-plus" style={{ marginRight: '5px' }}></i>} */}
                                    {list.assigned_user?.map((user, index) => (
                                        <Avatar key={index} style={{ fontSize: "14px", width: '25px', height: '25px', color: 'black', marginRight: "2px" }} image={getImageById(user?.id)} shape='circle' label={getInitials(getNameById(user.id))} />
                                    ))}
                                </div>
                                <div><i onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(list)
                                }} className="pi pi-trash" style={{ marginRight: '5px' }}></i></div>
                            </FlexComponent>
                        </div>
                    </FlexComponent>
                ) : (
                    <div className="applicantDivs editCheckListDiv" style={{ width: "100%" }} >
                        <Mention
                            value={editCheckListValue}
                            onChange={(e) => {
                                setEditCheckListValue(e.target.value)
                            }}
                            suggestions={suggestions}
                            onSearch={onSearch}
                            field="label"
                            placeholder="Edit comment..."
                            // rows={1}
                            cols={50}
                            itemTemplate={itemTemplate}
                            className="edit-mention-input"
                            style={{ width: "98%", marginLeft: "0.5rem" }}
                        />

                        {/* Existing + New Files */}
                        <div style={{ marginTop: "5px", marginLeft: "0.5rem" }}>
                            <FlexComponent gap="0.5rem" style={{ marginTop: ".5rem" }}>

                                {/* <FileUpload
                                    ref={fileUploadRef}
                                    mode="basic"
                                    name="files"
                                    multiple
                                    accept="*"
                                    maxFileSize={10000000}
                                    customUpload
                                    auto={false}
                                    chooseLabel={files?.length > 0 ? `${files?.length} file(s)` : "Add Files"}
                                    onSelect={(e) => {
                                        const selectedFiles = e.files;
                                        const mappedFiles = selectedFiles.map(file => ({
                                            file,
                                            editedName: file.name
                                        }));

                                        setFiles(prev => [...prev, ...mappedFiles]);
                                        fileUploadRef.current.clear();
                                    }}
                                    style={{
                                        border: "1px solid white",
                                        borderRadius: "5px",
                                        padding: "2px"
                                    }}
                                /> */}

                                <FlexComponent justifyContent="center" gap="1rem" >
                                    <FlexComponent style={{ border: "none", boxShadow: "none" }} justifyContent="start" >
                                        <span onClick={(e) => editAssignOp.current.toggle(e)} style={{ display: "flex", alignItems: "center", cursor: "pointer" }} ><i className="pi pi-user-plus" style={{ marginRight: '5px' }}></i>
                                            {editAssignedUsers?.length > 0 ? (
                                                <>
                                                    {editAssignedUsers?.map((id, index) => (
                                                        <Avatar key={index} style={{ fontSize: "14px", width: '25px', height: '25px', color: 'black', marginRight: "2px" }} image={getImageById(id)} shape='circle' label={getInitials(getNameById(id))} />
                                                    ))}
                                                    {/* {editAssignedUsers.length > 1 && <span style={{ marginLeft: ".2rem", padding: ".2rem", background: "white", color: "black", borderRadius: "25px" }}>+{editAssignedUsers.length - 1}</span>} */}
                                                </>
                                            ) :
                                                'Assign'}
                                        </span>
                                    </FlexComponent>


                                    <FlexComponent style={{ border: "none", boxShadow: "none" }} justifyContent="start" >
                                        <span style={{ cursor: "pointer" }}
                                            onClick={(e) => editDueDateOp.current.toggle(e)}
                                        ><i className="pi pi-clock" style={{ marginRight: '5px' }}></i>
                                            {(list.due_date || editDueDate) ? <span>{editDueDate ? convertDateToDateString(editDueDate) : list.due_date}</span> : <span>Due Date</span>}
                                        </span>
                                    </FlexComponent>
                                </FlexComponent>

                            </FlexComponent>

                            {(files?.length > 0 || list.file_url?.length > 0) && (
                                <div style={{ marginTop: "5px" }}>

                                    {existingFiles?.map((file, index) => {
                                        if (removedFileIds.includes(file.id)) return null;

                                        return (
                                            <FlexComponent
                                                key={`existing-${index}`}
                                                alignItems="center"
                                                gap=".5rem"
                                                style={{
                                                    maxWidth: "400px",
                                                    padding: "5px",
                                                    border: "1px solid grey",
                                                    marginTop: "3px",
                                                    borderRadius: "5px"
                                                }}
                                            >
                                                <div style={{ width: "100%" }}>
                                                    <i className="pi pi-folder" />

                                                    <input
                                                        type="text"
                                                        value={file.editedName}
                                                        onChange={(e) => {
                                                            const updatedFiles = [...existingFiles];

                                                            updatedFiles[index].editedName = e.target.value;

                                                            setExistingFiles(updatedFiles);
                                                        }}
                                                        style={{
                                                            marginLeft: ".5rem",
                                                            fontSize: "14px",
                                                            width: "250px"
                                                        }}
                                                    />
                                                </div>

                                                <i
                                                    className="pi pi-trash"
                                                    style={{ cursor: "pointer", fontSize: "12px" }}
                                                    onClick={() => {
                                                        setRemovedFileIds(prev => [...prev, file.id]);
                                                    }}
                                                />
                                            </FlexComponent>
                                        );
                                    })}

                                    {/* Newly added files */}
                                    {files.map((item, index) => (
                                        <FlexComponent
                                            key={index}
                                            alignItems="center"
                                            gap="0.3rem"
                                            style={{
                                                marginTop: "5px",
                                                maxWidth: "400px",
                                                padding: "5px",
                                                border: "1px solid grey",
                                                borderRadius: "5px",
                                                background: "green"
                                            }}
                                        >
                                            <div style={{ width: "100%" }}>
                                                <i className="pi pi-folder" />

                                                <input
                                                    type="text"
                                                    value={item.editedName}
                                                    onChange={(e) => {
                                                        const updatedFiles = [...files];

                                                        updatedFiles[index].editedName = e.target.value;

                                                        setFiles(updatedFiles);
                                                    }}
                                                    style={{
                                                        marginLeft: ".5rem",
                                                        fontSize: "14px",
                                                        width: "250px"
                                                    }}
                                                />
                                            </div>

                                            <i
                                                className="pi pi-trash"
                                                style={{ cursor: "pointer", fontSize: "12px" }}
                                                onClick={() => {
                                                    setFiles(prev => prev.filter((_, i) => i !== index));
                                                    fileUploadRef.current.clear();
                                                }}
                                            />
                                        </FlexComponent>
                                    ))}
                                </div>
                            )}
                            <FileUpload
                                ref={fileUploadRef}
                                name="files"
                                multiple
                                accept="*"
                                maxFileSize={30000000}
                                customUpload
                                auto={false}
                                mode="advanced"
                                chooseLabel=""                    // Hide browse button text
                                uploadLabel=""                    // Hide upload button
                                cancelLabel=""                    // Hide cancel button
                                emptyTemplate={
                                    <div
                                        style={{
                                            padding: "1rem",
                                            marginTop: ".75rem",
                                            textAlign: "center",
                                            color: "#999",
                                            border: "2px dashed #666",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                            // background: "#f8f9fa",
                                            transition: "all 0.2s"
                                        }}
                                        onClick={() => fileUploadRef.current?.getInput().click()} // Make whole area clickable
                                    >
                                        <i
                                            className="pi pi-cloud-upload"
                                            style={{ fontSize: "2.5rem", marginBottom: "12px", color: "#606160" }}
                                        />
                                        <p style={{ margin: "0 0 8px 0", fontSize: "15px" }}>
                                            Drag and drop files here
                                        </p>
                                        <small style={{ color: "#666" }}>
                                            or <strong style={{ color: "#606160" }}>click to browse</strong>
                                        </small>
                                    </div>
                                }
                                onSelect={(e) => {
                                    const selectedFiles = e.files;

                                    const mappedFiles = selectedFiles.map(file => ({
                                        file,
                                        editedName: file.name
                                    }));

                                    setFiles(prev => [...prev, ...mappedFiles]);

                                    // Clear immediately so duplicate uploads don't show in default UI
                                    setTimeout(() => {
                                        fileUploadRef.current?.clear();
                                    }, 100);
                                }}
                                style={{
                                    width: "100%",
                                    // maxWidth: "400px"
                                }}
                            />
                        </div>

                        <FlexComponent className="editChecklistSaveSection" >
                            <FlexComponent gap="0.5rem" justifyContent="start" style={{ marginTop: ".5rem" }} >
                                <Button style={{ padding: "0.4rem 1rem", background: "#2FC635", border: "1px solid grey" }} loading={saveEditLoading} onClick={() => {
                                    handleSaveEditCheckList(list)
                                }} >Save</Button>
                                <Button style={{ padding: "0.4rem 1rem", border: "1px solid grey" }} onClick={() => {
                                    setIsCheckListEdit(false)
                                    setEditAssignedUsers([])
                                    setEditCheckListValue('');
                                    setEditDueDate('')

                                    setFiles([]);
                                    setRemovedFileIds([]);
                                    if (fileUploadRef?.current) {
                                        fileUploadRef.current.clear();
                                    }
                                }} >Cancel</Button>
                            </FlexComponent>

                        </FlexComponent>
                        <OverlayPanel ref={editAssignOp} style={{ background: '#1A2B53', maxWidth: "400px" }} showCloseIcon>
                            <MultiSelect
                                value={editAssignedUsers}
                                options={usersList}
                                itemTemplate={userTemplate}
                                style={{ width: '100%', color: 'black' }}
                                onChange={(event) => {
                                    setEditAssignedUsers(event.value)
                                }}
                                placeholder='Select Members'
                                filter
                            />
                        </OverlayPanel>
                        <OverlayPanel ref={editDueDateOp} style={{ background: '#1A2B53' }} >
                            <Calendar id="buttondisplay" value={editDueDate} inline onChange={(e) => {
                                setEditDueDate(e.value)
                                editDueDateOp.current.toggle(e)
                            }} />
                        </OverlayPanel>
                    </div>
                )}
            </FlexComponent>

            {(!isCheckListEdit || checkListEditIndex !== index) && list?.file_url?.length > 0 &&
                <FlexComponent className="documentsSection" justifyContent="start" gap=".5rem" flexWrap="wrap" style={{ padding: "5px", border: "1px dotted grey", borderLeft: "none", borderRight: "none", borderBottom: "none" }} >
                    {list.file_url?.map((file, index) => {
                        // hide if already removed
                        if (removedFileIds.includes(file.id)) return null;

                        return (
                            <FlexComponent key={`existing-${index}`} gap=".5rem" justifyContent="start" width="auto" style={{ padding: "5px", border: "1px solid grey", borderRadius: "5px" }} >
                                <i style={{fontSize: "11px"}} className="pi pi-folder" />
                                <span
                                    style={{
                                        fontSize: "14px",
                                        maxWidth: "150px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        cursor: "pointer",
                                        fontSize: "11px"
                                    }}
                                    // onClick={() => window.open(file.file_url, "_blank")}
                                    onClick={() => openPreview(file)}
                                >
                                    {file.file_name}
                                </span>
                            </FlexComponent>
                        );
                    })}

                    <AppModal
                        // header={previewFile?.file_name || "Preview"}
                        header={headerElement}
                        visible={previewVisible}
                        panelStyle={{ width: '70vw', height: '90vh' }}
                        onHide={() => {
                            setPreviewVisible(false);
                            setPreviewFile(null);
                        }}
                    >
                        {previewFile && <PreviewFile isSingleFile={true} setPreviewVisible={setPreviewVisible} previewFile={previewFile} />}
                    </AppModal>
                </FlexComponent>
            }
        </div>
    )
}

export default CheckListItem